export default __webpack_public_path__ + "static/media/rainfal.d5ed693d.png";